import { render } from "./OrderEditor.vue?vue&type=template&id=5371fc1a&scoped=true"
import script from "./OrderEditor.vue?vue&type=script&lang=js"
export * from "./OrderEditor.vue?vue&type=script&lang=js"

import "./OrderEditor.vue?vue&type=style&index=0&id=5371fc1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5371fc1a"]])

export default __exports__